import { LocalePrefix, PrefixToLocaleMap } from '@tmh-website/shared/const';
import { defaultNS, languages, namespaces, resources } from '@tmh-website/shared/i18n';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const localeRegex = new RegExp(`\/(${Object.values(LocalePrefix).join('|')})`);

const activeLocale = PrefixToLocaleMap[localeRegex.exec(window.location.pathname)?.[1] ?? LocalePrefix.En];

i18n.use(initReactI18next).init({
  supportedLngs: languages,
  lng: activeLocale,
  ns: namespaces,
  defaultNS,
  resources,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
